import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Camera, CameraOff } from 'lucide-react';

const PEScannerCard = ({ scannerActive, startScanner, stopScanner, scannerContainerId }) => (
  <Card className="border-violet-200">
    <CardContent className="p-3">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="flex items-center gap-1.5 text-xs text-violet-600 font-medium">
          <span className="w-2 h-2 rounded-full bg-violet-500 animate-pulse" />
          Wireless Scanner Ready — scan any barcode
        </span>
        <div className="h-4 w-px bg-gray-300" />
        {scannerActive ? (
          <Button variant="destructive" size="sm" onClick={stopScanner} className="h-7 gap-1.5 text-xs" data-testid="pe-scanner-toggle">
            <CameraOff className="w-3 h-3" /> Stop Camera
          </Button>
        ) : (
          <Button variant="ghost" size="sm" onClick={startScanner} className="h-7 gap-1.5 text-xs text-gray-500" data-testid="pe-scanner-toggle">
            <Camera className="w-3 h-3" /> Live Camera
          </Button>
        )}
      </div>
      <div className={`mt-3 flex justify-center ${!scannerActive ? 'hidden' : ''}`}>
        <div id={scannerContainerId} className="w-full max-w-sm rounded-lg overflow-hidden border border-violet-200" data-testid="pe-scanner-view" />
      </div>
    </CardContent>
  </Card>
);

export default PEScannerCard;
